import React from "react";
import { withStyles } from '@material-ui/styles';

import pageStyles from "../../styles/page_styles.js";
import { infoPageStyles } from "../base_info_page.js";

import Readme from "./resources/MAILER_README.md";

import {
  Card,
  CardContent,
} from '@material-ui/core';

const styles = theme => ({
  root: {
    padding: "22px"
  }
});

class MailerReadmePage extends React.Component {

  render() {
    const { classes } = this.props;

    return <div className = { classes.page } 
                ref = { (ref) => this.scrollContainer = ref }>
      <div className = { classes.pageContent }
           ref = { (ref) => this.scrollContent = ref }  >
        <Card>
          <CardContent className = { classes.cardContent }>
            <div className = "markdown" 
                dangerouslySetInnerHTML = { {  
                  __html: Readme,
                }} />
          </CardContent>  
      </Card>
      </div>
    </div>
  }
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...styles(theme),
  }),
  { withTheme: true }
)(MailerReadmePage);